// Angular import
import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Location, LocationStrategy } from '@angular/common';

// project import
import { NavigationItem } from 'src/app/@theme/types/navigation';
import { ThemeLayoutService } from 'src/app/@theme/services/theme-layout.service';
import { HORIZONTAL, VERTICAL, COMPACT, RTL } from 'src/app/@theme/const';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { SessionWrapperService } from 'src/app/tabms/services/session/session-wrapper.service';
import { userInfo } from 'src/app/tabms/models/base/base';
import { AccountService } from 'src/app/tabms/services/admin/account/account.service';
import { environment } from 'src/environments/environment';
import { IEmployee } from 'src/app/tabms/models/self-services/employees/employee';
import { Subject, takeUntil } from 'rxjs';
import { userBranches } from 'src/app/tabms/models/admin/branch';
import { TranslateService } from '@ngx-translate/core';
import { EmployeeService } from 'src/app/tabms/services/hr-system/hr-management/employees/employee.service';
import { ApiSessionService } from 'src/app/tabms/services/global/api-session.service';

@Component({
  selector: 'app-vertical-menu',
  templateUrl: './vertical-menu.component.html',
  styleUrls: ['./vertical-menu.component.scss']
})
export class VerticalMenuComponent implements OnInit, AfterViewChecked, OnChanges {
  // public props
  @Input() menus: NavigationItem[];
  showUser: false;
  showContent = true;
  userName;
  userRole;
  profileImage: string;
  //menusfromDB: NavigationItem[];
  empDetails: IEmployee;
  sysCode: string;
  userCompany: string;
  currentLang: string;
  user: userInfo
  empId: string;
  private destroy$: Subject<void> = new Subject<void>();


  // Constructor
  constructor(
    private location: Location,
    private locationStrategy: LocationStrategy,
    private layout: ThemeLayoutService,
    private accountService: AccountService,
    private sessionService: SessionWrapperService,
    private baseService: BaseService,
    private changeDetector: ChangeDetectorRef,
    private translate: TranslateService,
    private empService: EmployeeService,
    private apiSessionService: ApiSessionService
  ) {
    this.currentLang = this.baseService.getCurrentLanguage();

    // this.themeLayoutService.directionChange.pipe(takeUntil(this.destroy$)).subscribe({
    //   next: (dir) => {
    //     (dir === RTL) ? this.currentLang = 'ar' : this.currentLang = 'en';
    //   }
    // })
    this.translate.onLangChange.subscribe((e) => {
      this.userCompany = e.lang === 'ar' ? this.user?.companyaraname : this.user?.companylatname;
    });

    this.sessionService.currentEmpId$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (empId) => {
        this.empId = empId;
        this.getEmpDetails(empId);
      }
    });
  }

  // public method
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['menus']?.currentValue && Array.isArray(this.menus)) {

      this.menus = [...this.menus].sort((a: any, b: any) => {
        const sa = typeof a?.sort === 'number' ? a.sort : parseInt(a?.sort, 10) || 0;
        const sb = typeof b?.sort === 'number' ? b.sort : parseInt(b?.sort, 10) || 0;
        return sa - sb;
      });
    }
  }
  fireOutClick() {
    let current_url = this.location.path();
    // console.log('current_url', current_url);
    const baseHref = this.locationStrategy.getBaseHref();
    if (baseHref) {
      current_url = baseHref + this.location.path();
      // console.log('current_url', current_url);
    }
    const link = "a.nav-link[ href='" + current_url + "' ]";
    // console.log('link', link);
    const ele = document.querySelector(link);
    if (ele !== null && ele !== undefined) {
      const parent = ele.parentElement;
      const up_parent = parent?.parentElement?.parentElement;
      const last_parent = up_parent?.parentElement;
      if (parent?.classList.contains('coded-hasmenu')) {
        parent.classList.add('coded-trigger');
        parent.classList.add('active');
      } else if (up_parent?.classList.contains('coded-hasmenu')) {
        up_parent.classList.add('coded-trigger');
        up_parent.classList.add('active');
      } else if (last_parent?.classList.contains('coded-hasmenu')) {
        last_parent.classList.add('coded-trigger');
        last_parent.classList.add('active');
      }
    }
  }

  ngOnInit(): void {
    this.sysCode = this.sessionService.getSysCode();

    this.layout.layout.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if (res == VERTICAL) {
        this.showContent = true;
      }
      if (res == HORIZONTAL) {
        this.showContent = false;
      }
      if (res == COMPACT) {
        this.showContent = false;
      }
    });

    let session = this.sessionService.getsessionData();
    this.accountService.GetUserLoginWithRoleData(session.userid).pipe(takeUntil(this.destroy$)).subscribe(
      (res) => {
        if (res) {
          this.user = res.result[0];
          this.userName = this.user?.username;
          this.userRole = this.currentLang == 'ar' ? this.user?.rolearaname : this.user?.rolelatname;
          this.profileImage = this.user?.pofileimage;
          this.userCompany = this.currentLang === 'ar' ? this.user?.companyaraname : this.user?.companylatname;
          let branchData: userBranches = {
            id: this.user.defaultbranchid,
            brancharaname: this.user.defaultbrancharaname,
            branchlatname: this.user.defaultbranchlatname,
            defaultbranch: true
          };
          this.sessionService.setDefaultBranch(branchData);
          let userId = this.user?.userid;
          // if(this.sysCode === '11') this.setEmpId(userId);
          if (!this.empId) this.setEmpId(userId);
          this.apiSessionService.changeUserCurrentBranch(this.user?.defaultbranchid);
        }
      },
      (error) => {
      }
    );

  }

  ngAfterViewChecked() {
    this.changeDetector.detectChanges();
  }

  setEmpId(userId: string): void {
    // debugger
    this.empService.getEmlpoyeeId(userId).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        if (res) {
          const empId = res;
          this.sessionService.setEmpId(empId);
          this.getEmpDetails(empId);
        }
      },
      error: (err) => {
      }
    })
  }

  getEmpDetails(empId) {
    this.empService.getEmlpoyee(empId).subscribe({
      next: (res) => {
        this.empDetails = res;
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
